import script from "./UWhoLate.vue?vue&type=script&setup=true&lang=ts"
export * from "./UWhoLate.vue?vue&type=script&setup=true&lang=ts"

import "./UWhoLate.vue?vue&type=style&index=0&id=4d3e1ef6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d3e1ef6"]])

export default __exports__